/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateUserRequest { 
    id: string;
    lastName: string;
    firstName: string;
    telegramLogin?: string | null;
    email: string;
    roleId: string;
}

